import { render, staticRenderFns } from "./ComplianceAlert.vue?vue&type=template&id=859adcd6&"
import script from "./ComplianceAlert.vue?vue&type=script&lang=js&"
export * from "./ComplianceAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports